import axios from 'axios';

export async function fetchMetaInfoFromCurrentPage() {
	try {
		const response = await axios.get(window.location.href);
		const dom = new DOMParser().parseFromString(response.data, 'text/html');
		const title = dom.querySelector('title')?.textContent || 'Default Title';
		const description = dom.querySelector('meta[name="description"]')?.getAttribute('content');

		return { title, description };
	} catch (error) {
		// console.error('Error fetching meta info:', error);
		return null;
	}
}